import {HTMLAttributes} from 'react';
import {AdfitLoader} from '../../../design-system/organisms/DisplayAd/AdfitLoader';
import {DisplayAdType} from '../../../design-system/organisms/DisplayAd/DisplayAdType.enum';
import {DaErrorBoundary} from '../../../errors/DaErrorBoundary.class';
import {DisplayAd, Maybe} from '../../../graphql/generated/types';
import {requestContext} from '../../requestContext';

export function DisplayAdContainer({
  displayAd,
  type = DisplayAdType.Normal,
  ...props
}: HTMLAttributes<HTMLDivElement> & {
  displayAd?: Maybe<DisplayAd>;
  type?: DisplayAdType;
}) {
  return (
    <DaErrorBoundary type={type} {...props}>
      <AdfitLoader
        type={type}
        displayAd={displayAd}
        isWebView={requestContext.requestInfo.display.isWebView}
        {...props}
      />
    </DaErrorBoundary>
  );
}
